import {
  defineStyle,
  StyleFunctionProps,
  SystemStyleInterpolation,
  SystemStyleObject,
} from '@chakra-ui/react';
import buttonSizes, { buttonSizeKeys } from './button.sizes';

/**@deprecated */
const filled = defineStyle({
  bg: 'yooga.500',
  color: 'white',
  _hover: {
    opacity: 0.7,
    _disabled: {
      bg: 'default',
    },
  },
});

/**@deprecated */
const outlined = defineStyle({
  border: '1px solid',
  bg: 'transparent',
  borderColor: 'yooga.500',
  color: 'yooga.600',
  _hover: {
    bg: 'yooga.100',
  },
});

const emphasisButton = (color: string) => {
  return defineStyle({
    bg: `${color}.300`,
    color: `${color}.800`,
    borderRadius: '12px',
    _hover: {
      bg: `${color}.200`,
      color: `${color}.800`,
    },
  });
};

const emphasisPrimary = emphasisButton('yPrimary');
const emphasisDanger = emphasisButton('yRed');
const emphasisSuccess = emphasisButton('yGreen');

const stroke = defineStyle((props: StyleFunctionProps) => {
  let theme = {
    borderWidth: '1px',
    borderColor: 'yGray.200',
    color: 'yGray.700',
    _hover: {
      borderColor: 'yGray.300',
      color: 'yGray.800',
    },
    _focus: {
      borderColor: 'yGray.300',
      color: 'yGray.800',
    },
  };
  if (props.colorScheme === 'selected') {
    theme = {
      borderWidth: '2px',
      borderColor: 'yPrimary.600',
      color: 'yPrimary.600',
      _hover: {
        borderColor: 'yPrimary.600',
        color: 'yPrimary.600',
      },
      _focus: {
        borderColor: 'yPrimary.600',
        color: 'yPrimary.600',
      },
    };
  }

  return {
    ...theme,
    borderRadius: '6px',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '16px',
    height: '44px',
    lineHeight: '24px',
  };
});

const plain = defineStyle((props: StyleFunctionProps) => {
  let size: SystemStyleInterpolation = {};
  if (buttonSizes.hasOwnProperty(props.size)) {
    const defaultSize = buttonSizes[props.size as buttonSizeKeys];
    if (props.size === 'small') {
      size = defineStyle({
        ...defaultSize,
        h: 10,
        padding: 4,
        fontSize: 'xs',
      });
    }
  }
  const theme: SystemStyleObject = {
    bg: 'transparent',
    color: 'yGray.700',
    borderRadius: '12px',
    _hover: {
      bg: 'yGray.50',
    },
    _disabled: {
      bg: 'yGray.50',
      cursor: 'auto',
    },
    _active: {
      bg: 'yGray.100',
      color: 'yGray.1000',
    },
  };
  if (props.colorScheme === 'selected') {
    theme.bg = 'yPrimary.100';
    theme.color = 'yPrimary.800';
    theme._hover.bg = 'yPrimary.100';
    theme._hover.color = 'yPrimary.800';
    theme._active.bg = 'yPrimary.100';
    theme._active.color = 'yPrimary.800';
  }
  return {
    ...size,
    ...theme,
  };
});

const regular = defineStyle((props: StyleFunctionProps) => {
  let size: SystemStyleInterpolation = {};
  if (buttonSizes.hasOwnProperty(props.size)) {
    const defaultSize = buttonSizes[props.size as buttonSizeKeys];
    if (props.size === 'small') {
      size = defineStyle({
        ...defaultSize,
        h: 10,
        padding: 4,
        fontSize: 'xs',
      });
    }
  }
  const theme: SystemStyleObject = {
    bg: 'yGray.100',
    color: 'yGray.700',
    borderRadius: '12px',
    _hover: {
      bg: 'yGray.50',
    },
    _disabled: {
      bg: 'yGray.50',
      color: 'yGray.200',
      cursor: 'auto',
    },
    _active: {
      bg: 'yGray.200',
      color: 'yGray.1000',
    },
  };
  return {
    ...size,
    ...theme,
  };
});

const plainIcon = defineStyle((props: StyleFunctionProps) => {
  const variant = plain(props);
  if (buttonSizes.hasOwnProperty(props.size)) {
    if (props.size === 'small') {
      variant.fontSize = 'lg';
    }
  }
  return variant;
});

const regularIcon = defineStyle((props: StyleFunctionProps) => {
  const variant = regular(props);
  if (buttonSizes.hasOwnProperty(props.size)) {
    if (props.size === 'medium') {
      variant.fontSize = 'sm';
    }
  }
  return variant;
});

const buttonVariants = {
  filled,
  outlined,
  stroke,
  plainIcon,
  plain,
  regular,
  regularIcon,
  emphasisPrimary,
  emphasisDanger,
  emphasisSuccess,
};
export default buttonVariants;
